<template>
  <div
    ref="footerCell"
    class="flex items-center gap-2 flex-nowrap relative"
    @mouseenter="showTooltip"
    @mouseleave="hideTooltip"
  >
    <div
      v-if="!hideSummation && showSummation"
      class="flex items-center"
    >
      <SummationIcon class="text-icon-normal w-5 h-5 flex-shrink-0" />
      <BaseText
        size="sm"
        class="text-text-muted"
      >
        {{ getIsPrivateMode ? '•••' : netKpi }}
      </BaseText>
    </div>
    <div v-else-if="showSummation">
      <BaseText
        size="sm"
        class="text-text-muted"
      >
        -
      </BaseText>
    </div>
    <div class="flex items-center gap-1.5">
      <div v-if="showWeightedAvg" class="flex items-center">
        <WeightIcon class="text-icon-normal w-5 h-5 flex-shrink-0" />
        <BaseText
          size="sm"
          class="text-text-muted"
        >
          {{ getIsPrivateMode ? '•••' : weightedAvgValue }}
        </BaseText>
      </div>
    </div>

    <!-- Tooltip -->
    <div
      ref="tooltip"
      class="footer-tooltip p-1 rounded"
      :style="tooltipStyle"
    >
      <div class="p-1.5">
        <BaseText
          class="text-white"
          type="label"
          size="xs"
        >
          Net Averages
        </BaseText>
      </div>
      <div class="bg-neutral-alpha-50 p-1 space-y-1 rounded">
        <div class="flex items-center gap-0.5 pr-1.5">
          <SummationIcon class="text-neutral-alpha-650 w-5 h-5 flex-shrink-0" />
          <BaseText
            class="text-neutral-alpha-650 flex-1"
            size="xs"
          >
            Sum
          </BaseText>
          <BaseText
            class="text-white"
            type="label"
            size="xs"
          >
            {{ getIsPrivateMode ? '•••' : hideSummation ? '-' : netKpi }}
          </BaseText>
        </div>
        <div class="flex items-center gap-0.5 pr-1.5">
          <WeightIcon class="text-neutral-alpha-650 w-5 h-5 flex-shrink-0" />
          <BaseText
            class="text-neutral-alpha-650 flex-1"
            size="xs"
          >
            Weighted Avg.
          </BaseText>
          <BaseText
            class="text-white"
            type="label"
            size="xs"
          >
            {{ getIsPrivateMode ? '•••' : weightedAvgValue }}
          </BaseText>
        </div>
        <div class="flex items-center gap-0.5 pr-1.5">
          <MeanIcon class="text-neutral-alpha-650 w-5 h-5 flex-shrink-0" />
          <BaseText
            class="text-neutral-alpha-650 flex-1"
            size="xs"
          >
            Mean Avg.
          </BaseText>
          <BaseText
            class="text-white"
            type="label"
            size="xs"
          >
            {{ getIsPrivateMode ? '•••' : meanAvgValue }}
          </BaseText>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import WeightIcon from '../../../globals/Icons/LensIcons/WeightIcon.vue'
import MeanIcon from '../../../globals/Icons/LensIcons/MeanIcon.vue'
import SummationIcon from '../../../globals/Icons/LensIcons/SummationIcon.vue'
import { mapGetters } from 'vuex'
export default {
  name: 'FooterCell',
  components: {
    WeightIcon,
    MeanIcon,
    SummationIcon
  },
  props: {
    netKpi: {
      type: String,
      default: ''
    },
    weightedAvgValue: {
      type: String,
      default: '-'
    },
    meanAvgValue: {
      type: String,
      default: '-'
    },
    isAdLevel: {
      type: Boolean,
      default: false
    },
    kpiType: {
      type: String,
      default: ''
    },
    kpi: {
      type: String,
      default: ''
    },
    showWeightedAvg: {
      type: Boolean,
      default: true
    },
    showSummation: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      showTooltipFlag: false,
      tooltipStyle: {
        opacity: '0',
        top: '0px',
        left: '0px'
      }
    }
  },
  computed: {
    ...mapGetters('MiscModule', ['getIsPrivateMode']),
    hideSummation () {
      return this.kpiType === 'percent' || this.kpi === 'roas'
    }
  },
  methods: {
    showTooltip () {
      this.showTooltipFlag = true
      this.$nextTick(() => {
        this.positionTooltip()
      })
    },
    hideTooltip () {
      this.showTooltipFlag = false
      this.tooltipStyle.opacity = '0'
    },
    positionTooltip () {
      if (!this.$refs.tooltip || !this.$refs.footerCell) return

      const tooltip = this.$refs.tooltip
      const reference = this.$refs.footerCell

      const tooltipRect = tooltip.getBoundingClientRect()
      const referenceRect = reference.getBoundingClientRect()

      // If ad level, take into consideration drawer spacing
      const offset = this.isAdLevel ? 88 : 8
      // Position tooltip above the cell, centered horizontally
      const position = {
        top: referenceRect.top - tooltipRect.height - offset,
        left: referenceRect.left + (referenceRect.width / 2) - (tooltipRect.width / 2)
      }

      // Ensure tooltip doesn't go off screen
      if (position.left < offset) {
        position.left = offset
      } else if (position.left + tooltipRect.width > window.innerWidth - offset) {
        position.left = window.innerWidth - tooltipRect.width - offset
      }

      // If tooltip would go above viewport, show it below instead
      if (position.top < offset) {
        position.top = referenceRect.bottom + offset
      }

      this.tooltipStyle = {
        opacity: '1',
        top: `${position.top}px`,
        left: `${position.left}px`,
        transition: 'opacity 150ms ease'
      }
    }
  }
}
</script>

<style scoped>
.footer-tooltip {
  pointer-events: none;
  z-index: 40001;
  position: fixed;
  border-radius: 8px;
  background: rgba(6, 7, 16, 0.88);
  backdrop-filter: blur(4px);
  min-width: 180px;
  max-width: 220px;
  width: 100%;
  opacity: 0;
}
</style>
